import request from '@/utils/request'

export function fetchSpeciesList(query) {
  return request({
    url: 'api/pet_species/speciesList',
    method: 'get',
    params: query
  })
}